//==================================
// GetNewEvent
//==================================
window.GetNewEvent = function(eventName){

    //Not-IE
    if (typeof(Event) === 'function') {
        return new Event(eventName);
    }
    else {
        //IE
        var event = document.createEvent('Event');
        event.initEvent(eventName, true, true);
        return event;
    }
};

//==================================
// closest
//==================================
if (!Element.prototype.closest) {
  Element.prototype.closest = function(s) {
    var el = this;

    do {
      if (Element.prototype.matches.call(el, s)) return el;
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);
    return null;
  };
}

//==================================
// matches
//==================================
if (!Element.prototype.matches) {
  Element.prototype.matches =
    Element.prototype.msMatchesSelector || 
    Element.prototype.webkitMatchesSelector;
}
